<template>
  <v-container fluid>
    <material-card icon="mdi-google-classroom" title="Edit onboarded student class details">
      <v-card-actions>
          <router-link slot="right" :to="{ name: 'viewMotherToddlerProgram' }">
            <v-btn v-if="$vuetify.breakpoint.smAndUp" elevation="1" absolute right top> <v-icon left>mdi-arrow-left</v-icon>Back</v-btn>
            <v-btn v-else fixed right fab small color="grey lighten-2" elevation="1" class="mr-n2 mt-10" style="opacity:.6;"> <v-icon>mdi-arrow-left</v-icon></v-btn>
          </router-link>
        </v-card-actions>
        <v-card-component>
          <v-row>
            <v-col cols="12" lg="12" sm="12">
               <v-card v-for="title in titles" :key="title">
            <v-card-title>
              {{title}}
              <v-spacer></v-spacer>
            </v-card-title>

              <v-data-table
            :headers="headers"
            :items="getTableItems(title)"
            :hide-default-footer="true"
          >
            <template v-slot:item.className="{ item }">
              {{ item.studentAdmission.class || '-' }}
            </template>
              <template v-slot:item.section="{ item }">
              {{ item.studentAdmission.section || '-' }}
            </template>
             <template v-slot:item.classStartDate="{ item }">
              {{ formatDate(item.classStartDate) || '-' }}
            </template>
             <template v-slot:item.classEndDate="{ item }">
              {{ formatDate(item.classEndDate) || '-' }}
            </template>
            <template v-slot:item.actions="{ item }">
          <v-btn outlined @click="editModalOpen(item)" class="px-2 ml-1 ma-1" color="success" min-width="0" small> Edit Class </v-btn>
        </template>

            <template v-slot:no-data>
              <v-card-subtitle class="d-flex justify-center">No Data Available</v-card-subtitle>
            </template>
          </v-data-table>
          </v-card>
              </v-col>
              </v-row>
        </v-card-component>
        <v-dialog
        persistent
        v-model="editModal"
        :active="editModal"
        :on-cancel="
          () => {
            editModal = false
          }
        "
        max-width="800"
      >
        <form @submit.prevent="saveEditedClass()">
          <v-card>
            <v-toolbar dark color="darkblue">
              <v-toolbar-title> Edit Class of {{ selectedClassName }} and section {{selectedSectionName}}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn icon dark @click="editModal = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar-items>
            </v-toolbar>
            <v-card-text>
              <v-row>
                <v-col cols="12" md="6">
                <label class="font-weight-medium body-2">
                Class Start Date
                <span class="requir error--text">*</span>
              </label>
                <custom-date-picker @input="changeClassEndDate()" v-model="classStartDate"/>

              </v-col>
              <v-col cols="12" md="6" >
                <label class="font-weight-medium body-2">
                Class End Date
                <span class="requir error--text">*</span>
              </label>
                <v-text-field class="ml-5 mb-1" v-model="classEndDate" disabled></v-text-field>

               </v-col>
                <v-col cols="12">
                  <v-card-actions class="justify-end">
                    <v-btn type="submit" color="accent">Edit</v-btn>
                  </v-card-actions>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </form>
    </v-dialog>
    </material-card>
  </v-container>
</template>
<script>
import constants from '@/utils/constants'
import MaterialCard from '@/components/template/MaterialCard'
import moment from 'moment'
import CustomDatePicker from '@/components/template/CustomDatePicker'
import VCardComponent from '@/components/template/VCardComponent'

export default {
  name: 'viewStudentClassDetails',
  props: ['studentID'],
  components: { MaterialCard, CustomDatePicker, VCardComponent },
  data () {
    return {
      activeTab: null,
      titles: ['Current classes', 'Upcoming classes'],
      headers: [
        { text: 'Class Name', value: 'className' },
        { text: 'Section', value: 'section' },
        { text: 'Class Start Date', value: 'classStartDate' },
        { text: 'Class End Date', value: 'classEndDate' },
        { text: 'Action', value: 'actions' }
      ],
      onboardedStudentList: null,
      currentClassList: [],
      upcomingClassList: [],
      title: null,
      editModal: false,
      selectedClassName: '',
      selectedSectionName: '',
      selectedClass: '',
      classStartDate: '',
      classEndDate: moment().add(60, 'days').format('YYYY-MM-DD')
    }
  },
  async created () {
    await this.getAllOnboardedStudentList()
  },

  methods: {
    getAllOnboardedStudentList: async function () {
      try {
        const { data } = await http.get(`${constants.API_URL}/api/mother-toddler/classes/${this.studentID}`)
        this.onboardedStudentList = data
        this.currentClassList = data.currentClass
        this.upcomingClassList = data.upComingClasses
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error while getting student list data: ${errorMessage}`)
      }
    },
    getTableItems (title) {
      switch (title) {
        case 'Current classes':
          return this.currentClassList
        case 'Upcoming classes':
          return this.upcomingClassList
        default:
          return []
      }
    },
    editModalOpen (ele) {
      this.editModal = true
      this.selectedClass = ele.id
      this.selectedClassName = ele.studentAdmission.class
      this.selectedSectionName = ele.studentAdmission.section
      this.classStartDate = moment(ele.classStartDate).format('YYYY-MM-DD')
      this.classEndDate = moment(ele.classEndDate).format('YYYY-MM-DD')
    },
    changeClassEndDate: async function () {
      if (this.classStartDate) {
        this.classEndDate = moment(this.classStartDate).add(60, 'days').format('YYYY-MM-DD')
      } else {
        this.classEndDate = null
      }
    },
    formatDate (date) {
      return moment(date).format('DD/MM/YYYY')
    },
    saveEditedClass: async function () {
      this.loader = true
      try {
        let formData = {
          classStartDate: this.classStartDate,
          classEndDate: this.classEndDate
        }
        await http.put(`${constants.API_URL}/api/mother-toddler/detail/update/${this.selectedClass}`, formData)
        this.$router.push({ name: 'editStudentClassDetails', params: { studentID: this.studentID } })
        this.okMsg('Class details saved successfully!')
        this.getAllOnboardedStudentList()
        this.editModal = false
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error While Saving Class: ${errorMessage}`)
      }
    },
    okMsg (msg) {
      return this.$dialog.info({
        title: 'Success',
        text: msg
      })
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    }
  }
}
</script>
